<template>
	<!-- 专题 -->
	<div class="kr-layout-content">
		<div class="content-left">
			<!--专题信息-->
			<div class="new-article">
				<div class="look-imgs">
					<img :src="imgUrl" alt />
				</div>
				<p v-if="read" style="padding:10px 0px 0px 10px;font-size:18px;">导读</p>
				<div class="intro-des">
					<p v-text="intro"></p>
				</div>
				<!--深度研究-->
				<div class="shenduyanjiu">
					<ul class="art-list">
						<p v-if="wz" style="margin:10px auto;padding-left:10px;font-size:18px;">深度研究</p>
						<li v-for="(item,i) in lists_shendu" :key="i" v-if="item.type != 2" @click="toDetail(item.id,item.type)"
							class="wenz">
							<div class="head-img">
								<img :src="item.pic" alt />
							</div>
							<div class="content">
								<div class="title">
									<p class="twoline">{{item.title}}</p>
								</div>
								<p class="intro oneline">{{item.subTitle}}</p>
								<div class="author">
									<div class="author-img" style="margin-right:10px;">
										<img :src="item.userHeadPic" alt />
									</div>
									<p class="name">
										{{item.userName }}
										<span>.</span>
										{{item.createTime}}
									</p>
								</div>
							</div>
						</li>
					</ul>
					<div v-if="lists_shendu.length > 0 && loadmore_shendu" class="look-more" @click="pageMoreShendu">查看更多</div>
					<p v-if="lists_shendu.length > 0 && !loadmore_shendu" class="none-more">没有更多了</p>
				</div>
				<!--视频记录-->
				<div class="shipinjilu">
					<ul class="art-list">
						<p v-if="sp" style="margin:10px auto;padding-left:10px;font-size:18px;">视频记录</p>
						<li v-for="(item,i) in lists_shipin" :key="i" v-if="item.type == 2" @click="toDetail(item.id,item.type)"
							class="ship">
							<div class="head-img">
								<img :src="item.pic" alt />
							</div>
							<div class="content">
								<div class="title">
									<p class="twoline">{{item.title}}</p>
								</div>
								<p class="intro oneline">{{item.subTitle}}</p>
								<div class="author">
									<div class="author-img" style="margin-right:10px;">
										<img :src="item.userHeadPic" alt />
									</div>
									<p class="name">
										{{item.userName }}
										<span>.</span>
										{{item.createTime}}
									</p>
								</div>
							</div>
						</li>
					</ul>
					<div v-if="lists_shipin.length > 0 && loadmore_shipin" class="look-more" @click="pageMoreShipin">查看更多</div>
					<p v-if="lists_shipin.length > 0 && !loadmore_shipin" class="none-more">没有更多了</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from "jquery";
	export default {
		data() {
			return {
				id: this.$route.query.id,
				imgUrl: this.$route.query.imgUrl,
				keyWord: null,
				lists_shendu: [],
				lists_shipin: [],
				loadmore_shendu: true,
				loadmore_shipin: true,
				curPage_shendu: 1,
				curPage_shipin: 1,
				intro: "",
				wz: false,
				sp: false,
				read: false,
				limit: 10
			};
		},
		methods: {
			toDetail(id, type) {
				if (type == 1) {
					this.$router.push({
						path: "/ghDetails",
						query: {
							id: id,
							type: type
						}
					});
				} else {
					this.$router.push({
						path: "/vdDetails",
						query: {
							id: id,
							type: type
						}
					});
				}
			},
			// 点击深度研究更多
			pageMoreShendu() {
				this.getDataShendu()
			},
			// 点击视频记录更多
			pageMoreShipin() {
				this.getDataShipin()
			},
			// 获取深度研究数据
			getDataShendu() {
				this.$http
					.get(
						"/api/core/016--zhuanTiNewsList?id=" +
						this.id +
						"&pageNo=" +
						this.curPage_shendu + '&limit=' + this.limit
					)
					.then(res => {
						var self = this;
						if (res.data.code == 0) {
							$(res.data.rows).each(function(k, v) {
								self.lists_shendu.push(...v.news);
								$.each(v.news, function(i, n) {
									if (n.type == 2) {
										self.sp = true;
									} else if (n.type == 1 || n.type == 3) {
										self.wz = true;
									} else {
										self.wz = false;
										self.sp = false;
									}
								});
							});
							if (res.data.rows.length > 0) {
								this.intro = res.data.rows[0].des;
								if (res.data.rows[0].des != '') {
									this.read = true;
								} else {
									this.read = false;
								}
							}

							if (this.curPage_shendu >= res.data.totalPage) {
								this.loadmore_shendu = false;
							}
							this.curPage_shendu++;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			// 获取视频记录数据
			getDataShipin() {
				this.$http
					.get(
						"/api/core/016--zhuanTiNewsList?id=" +
						this.id +
						"&pageNo=" +
						this.curPage_shipin + '&limit=' + this.limit
					)
					.then(res => {
						var self = this;
						if (res.data.code == 0) {
							$(res.data.rows).each(function(k, v) {
								self.lists_shipin.push(...v.news);
								$.each(v.news, function(i, n) {
									if (n.type == 2) {
										self.sp = true;
									} else if (n.type == 1 || n.type == 3) {
										self.wz = true;
									} else {
										self.wz = false;
										self.sp = false;
									}
								});
							});
							if (res.data.rows.length > 0) {
								this.intro = res.data.rows[0].des;
								if (res.data.rows[0].des != '') {
									this.read = true;
								} else {
									this.read = false;
								}
							}
			
							if (this.curPage_shipin >= res.data.totalPage) {
								this.loadmore_shipin = false;
							}
							this.curPage_shipin++;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			newsMore() {
				this.loadmore = !this.loadmore;
			}
		},
		created() {
			this.keyWord = this.$route.query.keyWord;
			this.getDataShendu();
			this.getDataShipin();
		}
	};
</script>
<style scoped>
	.content-left {
		width: 100%;
		padding: 30px 10px 60px 20px;
	}

	.content-left .post-details {
		width: 100%;
	}

	.look-imgs {
		width: 100%;
		height: 240px;
		border: 10px solid #fff;
		box-sizing: border-box;
		overflow: hidden;
		position: relative;
	}

	.look-imgs:hover {
		box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.16);
	}

	.look-imgs:hover img {
		transform: scale(1.1, 1.1);
		transition: all 0.6s linear;
	}

	.look-imgs img {
		width: 100%;
		height: auto;
		transition: all 0.6s linear;
	}
</style>
<style>
	.intro-des {
		width: 100%;
		height: auto;
		background: #f7f7f7;
		box-sizing: border-box;
		border: 10px solid #fff;
		color: #333;
		margin: 0px auto 8px;
		padding: 10px;
	}
</style>
